import { Button } from 'antd';
import { useTranslate } from '@tolgee/react';
import { exportAssignConversationStores } from 'services/api/department/department';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { useExportFile } from 'components/ExportCenter/hooks/useExportCenter';

type postData = Parameters<typeof exportAssignConversationStores>[0];

type ExportExcelProps = {
  departmentId: number;
  keyword?: string;
};

function ExportExcel(props: ExportExcelProps) {
  const { departmentId, keyword } = props;
  const { t } = useTranslate();
  const lang = useSystemLanguageValue();
  const { run, loading: exportLoading } = useExportFile();
  const exportIt = () => {
    const postData: postData = {
      departmentId,
      keyword: keyword ?? '',
      language: lang,
    };
    run(() => exportAssignConversationStores(postData));
  };

  return (
    <Button loading={exportLoading} onClick={exportIt}>
      {t('department.导出咨询分配明细')}
    </Button>
  );
}

export default ExportExcel;
